<template>
  <div class="groupcreate">
    <v-container grid-list-md text-xs-center>
      <v-layout >
        <v-flex xs8 >
         <form
            name="GroupForm"
            autocomplete="off">
            <h2 class="text-xs-left">Edit group</h2>
            <v-text-field
              class="mt-2"
              label="Group name"
              required
              :rules="[required]"
              v-model="group.GroupName"
              outlined
            ></v-text-field>
            <v-text-field
              label="Grupa je podgrupda ID:"
              v-model="group.GroupBelongsTo"
              outlined
            ></v-text-field>
            <v-row no-gutters>
              <v-col cols="12" sm="10" md="12" lg="12" xl="12" >
                  <v-autocomplete
                    label="KPD (Klasus) šifra"
                    :items="$store.state.klasus"
                    v-model="selectKlasus"
                    item-text="klasusFind"
                    item-value="id"
                    return-object
                    @change="choosedKlasus(selectKlasus)"
                    clearable
                    outlined
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="10" md="12" lg="12" xl="12" >
                <v-btn text small color="primary" @click="updateItemsKPD" class="mr-1">
                    Dodaj KPD šifru u sve artikle iz grupe
                  </v-btn>
              </v-col>
            </v-row>
          </form>
          <br>
          <div class="pink darken-2" v-html="error" />
          <br>
          <v-btn
            class="primary mr-2"
             :disabled="!formIsValid"
            @click="updateGroup"
            >
            {{langC.Save}}
          </v-btn>
          <v-btn
            color="green"
            @click="grouplist">
            {{langC.Back}}
          </v-btn>
      </v-flex>
    </v-layout>
    </v-container>

  </div>
</template>

<script>

import GroupService from '@/services/GroupService'
import ItemService from '@/services/ItemService'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'

export default {
  name: 'groupedit',
  $validates: true,
  data () {
    return {
      lang: {},
      langC: {},
      menu: false,
      modal: false,
      msg: '',
      valid: true,
      group: {
      },
      locUpdatedAt: '',
      error: null,
      required: (value) => !!value || 'Required.',
      mainQuery: {},
      selectKlasus: {},
      potpunaSifra: ''
    }
  },
  components: {
  },
  async mounted () {
    try {
      if (this.$store.state.language === 'EN') {
        this.langC = commEn
      }
      if (this.$store.state.language === 'HR') {
        this.langC = commHr
      }
       if (this.$store.state.companyid) {
          this.mainQuery.CompanyId = this.$store.state.companyid
        }
        console.log('state group ', this.$store.state.groupid)
        const dbGroup = await GroupService.show(this.$store.state.groupid)
        this.group = dbGroup.data.group
        console.log('Grupa ', this.group)
        this.$store.dispatch('seteditItem', 0)
      
    } catch (error) {
      // eslint-disable-next-line
      console.log('greska kod monut dokumenta', error)
    }
  },
  computed: {
    formIsValid () {
      return this.group.groupName !== ''
    }
  },
  methods: {
    async updateGroup () {
      try {
        // if (this.$store.state.user) {
        //   this.group.LastUpdateBy = this.$store.state.user.email
        // }
        await GroupService.put(this.group)
        this.groupsLoc = (await GroupService.index(this.mainQuery)).data.groups
        if (this.groupsLoc) {
          this.$store.dispatch('setActivGroups', this.groupsLoc)
        }
        this.$router.push({
          name: 'group'
        })
      } catch (error) {
        this.error = error.response.data.error
      }
    },
    choosedKlasus (choosedK) {
      if (choosedK) {
        const result = this.$store.state.klasus.filter(element => element.id === choosedK.id)
        if (result[0]) {
          const res = result[0]
          this.potpunaSifra= res.PotpunaSifra
          this.selectKlasus = res
        } 
      } else {
        this.potpunaSifra = null
      }     
    },
    async updateItemsKPD() {
      if (confirm('Da li ste sigurni da želite svim artiklima iz grupe dodati šifru ' + this.potpunaSifra +' iz KPD klasusa ?')) {
        const upQuery = {
          companyid: this.$store.state.companyid,
          groupid: this.group.id,
          groupName: this.group.GroupName,
          potpunaSifra: this.potpunaSifra
        }
        await ItemService.updatekpd(upQuery)
        .then(res => {
          alert('OK, dodana je kpd sifra u artikle!.')
        })
        .catch(err => {
          alert('Doslo je do greske kod upisa !')
          console.log('err', err)
        })
      }
    },  
    close () {
      this.show = false
    },
    async grouplist () {
      try {
        await this.$router.push({
          name: 'group'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>
